module.exports = __webpack_public_path__ + "img/003-wind-11.8749bc39.svg";